import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Twitter } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="dark-footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3 className="footer-heading">genTechStaffing</h3>
          <p className="footer-text">
            Your trusted partner for IT solutions, staffing, and digital transformation.
          </p>
          <div className="footer-social">
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-link">
              <Linkedin size={20} />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-link">
              <Twitter size={20} />
            </a>
          </div>
        </div>

        <div className="footer-section">
          <h4 className="footer-heading">Technology Services</h4>
          <div className="footer-links">
            <Link to="/services/robotic-process-automation" className="footer-link">RPA</Link>
            <Link to="/services/erp-crm-solutions" className="footer-link">ERP / CRM</Link>
            <Link to="/services/application-development" className="footer-link">App Development</Link>
            <Link to="/services/it-staffing-solutions" className="footer-link">IT Staffing</Link>
          </div>
        </div>

        <div className="footer-section">
          <h4 className="footer-heading">AI Services</h4>
          <div className="footer-links">
            <Link to="/services/ai-strategy-readiness-assessments" className="footer-link">AI Strategy</Link>
            <Link to="/services/generative-ai-llm-implementation" className="footer-link">Gen AI / LLM</Link>
            <Link to="/services/data-engineering-ml-ops" className="footer-link">Data & ML Ops</Link>
            <Link to="/services/ai-governance-ethics-risk-management" className="footer-link">AI Governance</Link>
            <Link to="/services/industry-specific-ai-solutions" className="footer-link">Industry AI</Link>
            <Link to="/services/ai-powered-workflow-automation" className="footer-link">AI Automation</Link>
            <Link to="/services/it-consulting" className="footer-link">IT Consulting</Link>
          </div>
        </div>

        <div className="footer-section">
          <h4 className="footer-heading">Workforce Solutions</h4>
          <div className="footer-links">
            <Link to="/services/employer-of-record" className="footer-link">Employer of Record</Link>
            <Link to="/services/agent-of-record" className="footer-link">Agent of Record</Link>
            <Link to="/services/direct-sourcing" className="footer-link">Direct Sourcing</Link>
            <Link to="/services/global-talent-solutions" className="footer-link">Global Talent</Link>
          </div>
        </div>

        <div className="footer-section">
          <h4 className="footer-heading">Company</h4>
          <div className="footer-links">
            <Link to="/about" className="footer-link">About Us</Link>
            <Link to="/case-studies" className="footer-link">Case Studies</Link>
            <Link to="/contact" className="footer-link">Contact</Link>
          </div>
        </div>

        <div className="footer-section">
          <h4 className="footer-heading">Contact Info</h4>
          <div className="footer-contact">
            <div className="contact-item">
              <Mail size={16} />
              <span>contact@gentechstaffing.com</span>
            </div>
            <div className="contact-item">
              <Phone size={16} />
              <span>(289) 633-4269</span>
            </div>
          </div>
        </div>

        <div className="footer-section">
          <h4 className="footer-heading">Canada Locations</h4>
          <div className="footer-links">
            <Link to="/locations/toronto" className="footer-link">Toronto</Link>
            <Link to="/locations/vancouver" className="footer-link">Vancouver</Link>
            <Link to="/locations/calgary" className="footer-link">Calgary</Link>
            <Link to="/locations/montreal" className="footer-link">Montreal</Link>
            <Link to="/locations/ottawa" className="footer-link">Ottawa</Link>
            <Link to="/locations/edmonton" className="footer-link">Edmonton</Link>
            <Link to="/locations/kitchener-waterloo" className="footer-link">Kitchener-Waterloo</Link>
            <Link to="/locations/quebec" className="footer-link">Québec</Link>
            <Link to="/locations/saskatoon" className="footer-link">Saskatoon</Link>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2025 genTechStaffing. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;